<template>
	<el-button
		v-if="mySubscription"
		circle
		style="margin-top: 10px; margin-left: 10px"
		@click="
			openSidebar(false)
			setS()
		"
	>
		<i class="el-icon-question" style="font-size: 1.5em"></i>
	</el-button>
</template>
<script>
import { mapGetters, mapMutations } from "vuex"

export default {
	name: "wiki-button",
	props: ["item"],
	created() {},
	computed: {
		...mapGetters({
			componente: "object/component",
			mySubscription: "organization/active_subscription"
		})
	},
	methods: {
		...mapMutations({
			openSidebar: "documents/TOGGLE_SIDEBAR",
			setSidebar: "documents/SIDEBAR_CONTENT"
		}),
		setS() {
			if (typeof this.item === "object") {
				this.setSidebar(this.item.val)
			} else {
				this.setSidebar(this.componente(this.item))
			}
		}
	}
}
</script>
<style scoped></style>
